import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredAgreementDetails: AnswerPathTreeNode = {
  path: 'insuredAgreementDetails ',
  nodeId: NodeIds.insuredAgreementDetails,
};
